// @ts-nocheck
import React, { useMemo, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Tasks } from 'common/src/utils/types';
import { Spinner } from '@nextui-org/react';
import ModalTask from '../tasks/modalTask/modalTask';
import { DAY_NAMES, MONTH_NAMES } from '../../types/constans';
// TODO estamos usando date-fns  ./src/components/tasks/modalTask/LeftColumn.tsx

moment.locale('es');

const localizer = momentLocalizer(moment);

const messages = {
  allDay: 'Todo el día',
  previous: 'Anterior',
  next: 'Siguiente',
  today: 'Hoy',
  month: 'Mes',
  week: 'Semana',
  day: 'Día',
  agenda: 'Agenda',
  date: 'Fecha',
  time: 'Hora',
  event: 'Evento',
  noEventsInRange: 'No hay eventos en este rango',
  showMore: (total) => `+ Ver más (${total})`,
};
interface TaskCalendarProps {
  tasks: Tasks[];
  isLoading: boolean;
  statusColors: Record<string, string>;
}

const TaskCalendar: React.FC<TaskCalendarProps> = ({ tasks, isLoading, statusColors }) => {
  const [selectedTask, setSelectedTask] = useState<Tasks | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getEventStyle = (event) => {
    return {
      style: {
        backgroundColor: statusColors[event.status] || '#757575', // Default gray
        borderRadius: '4px',
        opacity: 0.8,
        color: '#fff',
        border: 'none',
        display: 'block',
      },
    };
  };

  const events = useMemo(
    () =>
      tasks.map((task) => ({
        id: task.id,
        title: task.category,
        start: new Date(task.date),
        end: new Date(task.date),
        allDay: true,
        status: task.status,
        assigned_user_id: task.assigned_user_id,
      })),
    [tasks]
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSelectEvent = (event: any) => {
    const task = tasks.find((t) => t.id === event.id);
    if (task) {
      setSelectedTask(task);
      setIsModalOpen(true);
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-[500px]">
        <Spinner size="lg" color="secondary" />
      </div>
    );
  }

  return (
    <div className="h-[600px] bg-white rounded-lg shadow-sm">
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: '100%' }}
        views={['month', 'week', 'day']}
        messages={messages}
        formats={{
          monthHeaderFormat: (date) => `${MONTH_NAMES[date.getMonth()]} ${date.getFullYear()}`,
          weekdayFormat: (date) => DAY_NAMES[date.getDay()].slice(0, 3),
          dayFormat: (date) => DAY_NAMES[date.getDay()].slice(0, 3),
          dayRangeHeaderFormat: ({ start, end }) =>
            `${start.getDate()} - ${end.getDate()} de ${
              MONTH_NAMES[start.getMonth()]
            } ${start.getFullYear()}`,
        }}
        components={{
          toolbar: (toolbarProps) => <CustomToolbar {...toolbarProps} monthNames={MONTH_NAMES} />,
        }}
        eventPropGetter={getEventStyle}
        onSelectEvent={handleSelectEvent}
      />
      {selectedTask && (
        <ModalTask
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          task={selectedTask}
          onReset={() => {
            setSelectedTask(null);
            setIsModalOpen(false);
          }}
        />
      )}
    </div>
  );
};

const CustomToolbar = ({ onNavigate, label, view, onView, monthNames }) => {
  const goToBack = () => {
    onNavigate('PREV');
  };

  const goToNext = () => {
    onNavigate('NEXT');
  };

  const goToCurrent = () => {
    onNavigate('TODAY');
  };

  const customLabel = () => {
    const [month, year] = label.split(' ');
    const monthIndex = monthNames.findIndex((m) => m.toLowerCase().startsWith(month.toLowerCase()));
    return `${monthNames[monthIndex]} ${year}`;
  };

  return (
    <div className="flex justify-between items-center p-4 border-b border-gray-200">
      <div className="flex space-x-2">
        <button
          onClick={goToBack}
          className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
        >
          &lt;
        </button>
        <button
          onClick={goToNext}
          className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
        >
          &gt;
        </button>
      </div>
      <span className="text-lg font-semibold text-gray-700">{customLabel()}</span>
      <div className="flex space-x-2 items-center">
        <button
          onClick={goToCurrent}
          className="px-3 py-1 text-sm bg-purple-100 text-purple-600 hover:bg-purple-200 rounded-md transition-colors"
        >
          Hoy
        </button>
        {[
          { key: 'month', label: 'Mes' },
          { key: 'week', label: 'Semana' },
          { key: 'day', label: 'Día' },
        ].map((viewOption) => (
          <button
            key={viewOption.key}
            onClick={() => onView(viewOption.key)}
            className={`px-3 py-1 text-sm rounded-md transition-colors ${
              view === viewOption.key ? 'bg-purple-500 text-white' : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            {viewOption.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TaskCalendar;
